export const sessionIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Session Summary is where you can track student usage minutes and sessions.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '#refresh-button',
    intro: 'Click here to refresh the Session Summary.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the report data to Excel for analysis and sharing.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Session Summary for the selected date range and View.'
  },
  {
    element: '#date-controls-container',
    intro: 'Use these data controls to select the time period for which you want to view session or minutes data.'
  },
  {
    element: '#student-wrapper',
    intro: 'Use this filter to view sessions for a single student.'
  },
  {
    element: '#view-wrapper',
    intro: 'Select Sessions or Minutes from the dropdown.'
  },
  {
    element: 'table.report-table',
    intro: 'See the student session or minute data. The table includes the date, student Name, start time and end time for the Sessions View. The table includes the date, student name and minutes for the Minutes View. Click the top of any column to sort the column'
  }
];